import {
  GET_MINI_LEADERBOARD_SCORE_LIST_REQUEST,
  GET_MINI_LEADERBOARD_SCORE_LIST_SUCCESS,
  GET_MINI_LEADERBOARD_SCORE_LIST_FAILURE
} from 'Store/constants';
  
const initialState = {
  data: [],
  isLoading: false,
  error: null
};
    
export default (state = initialState, action ) => {
  switch (action.type) {
    case GET_MINI_LEADERBOARD_SCORE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case GET_MINI_LEADERBOARD_SCORE_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.leaderboardResponse.scores,
        isLoading: false,
        error: null
      };
    case GET_MINI_LEADERBOARD_SCORE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
      
    default:
      return state;
  }
};